import { gql } from '@apollo/client'

const fragments = {
  giftingPage: gql`
    fragment GiftingPageFragment on GiftingPage {
      id
      fundName
      photoUrl
      handle
      description
    }
  `,
}

export default fragments
